import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'

import config from '../../../../../../config'

import DropDown from '../../../../components/Ribbon/components/DropDown'
import ButtonsArray from '../../../../components/Ribbon/components/ButtonsArray'
import Separator from '../../../../components/Ribbon/components/Separator'
import ButtonsControls from '../../../../components/Ribbon/components/ButtonsControls'

import hocConnect from './hocConnect'

import './style.scss'

import { DROPDOWN_KEY, BUTTONSARRAY_KEY, BUTTONS_CONTROLS_KEY } from './constants'

const MODULE_NAME = config.modules.report.key

@hocConnect
export default class Ribbon extends Component {
    static propTypes = {
        buttons: IPropTypes.list.isRequired,
        reports: IPropTypes.list.isRequired,
    }

    render() {
        const { buttons, reports } = this.props

        return (
            <div className={`ribbon-${MODULE_NAME}`}>
                <DropDown moduleName={MODULE_NAME} name={DROPDOWN_KEY} configuration={reports} />
                <Separator />
                <ButtonsControls moduleName={MODULE_NAME} name={BUTTONS_CONTROLS_KEY} configuration={buttons} />
                <ButtonsArray moduleName={MODULE_NAME} name={BUTTONSARRAY_KEY} configuration={buttons} />
            </div>
        )
    }
}
